import * as PA from '../actions/paymentActions';


const initState = {
  confirmAuthorization: "",
  cancelAuthorization: ""
}

export default function caseActionReducer(state = {
  ...initState
}, action) {
  switch (action.type) {
    case PA.CONFIRM_AUTHORIZATION_REQUEST:
      return {
        ...state,
        confirmAuthorization: "trying"
      }
    case PA.CONFIRM_AUTHORIZATION_SUCCESS:
      return {
        ...state,
        confirmAuthorization: "success"
      }
    case PA.CONFIRM_AUTHORIZATION_FAILURE:
      return {
        ...state,
        confirmAuthorization: "failure"
      }
      case PA.CANCEL_AUTHORIZATION_REQUEST:
        return {
          ...state,
          cancelAuthorization: "trying"
        }
      case PA.CANCEL_AUTHORIZATION_SUCCESS:
        return {
          ...state,
          cancelAuthorization: "success"
        }
      case PA.CANCEL_AUTHORIZATION_FAILURE:
        return {
          ...state,
          cancelAuthorization: "failure"
        }
    default:
      return {
        ...state
      }
  }
}
